import BaseService from 'services/BaseService';
import moment from 'moment';

//-------------------------------------------------------------------------------------------------------------------

export default class CourseCheckerService
    extends BaseService {

    static async upload(file, startDate, endDate) {
        return BaseService.postFile('course-checker/upload', file, {
            startDate: moment(startDate).format('YYYY-MM-DD'),
            endDate: moment(endDate).format('YYYY-MM-DD')
        });
    }

}
